import { upperCase } from "lodash";

export const AnnouncementModel = {
  id: null,
  title: "",
  html: "",
  icon: "",
  link: "",
  creationDate: "",
  expirationDate: "",
  lastUpdate: "",
  author: "",
  agency: "",
  roadway: "",
  state: "",
  state2: null,
  priority: "MEDIUM",
  eventIds: [],
  weatherDotGovId: null,
  highPriorityPageOrder: 0,
  highPriorityPage: false,
  newsItem: false,
  siteNews: false,
  construction: false,
  transit: false,
  weather: false,
  trucker: false,
};

export const getStates = async (setStates) => {
  var endpoint = "/admin/announcements/states.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
    });
    res.json().then((res) => {
      setStates(res.data);
    });

    if (!res.ok) {
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {}
};

export const getAgencies = async (setAgencies) => {
  var endpoint = "/admin/announcements/agencies.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
    });
    res.json().then((res) => {
      setAgencies(res.data);
    });

    if (!res.ok) {
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {}
};

export const getRoadways = async (setRoadways) => {
  var endpoint = "/admin/announcements/roadways.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
    });
    res.json().then((res) => {
      setRoadways(res.data);
    });

    if (!res.ok) {
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {}
};

export const getPriorities = async (setPriorities) => {
  var endpoint = "/admin/announcements/priorities.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
    });
    res.json().then((res) => {
      setPriorities(res.data);
    });

    if (!res.ok) {
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {}
};

export const getEvents = async (id, setEvents) => {
  var endpoint = "/admin/announcements/events.json"
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
    });
    res.json().then((res) => {
      setEvents(res.data);
    });

    if (!res.ok) {
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {}
};

export const getAdminWebFiles = async(setAdminWebFiles) => {
  var endpoint = "/admin/webfiles/webfile/images"
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    res.json().then((res) => {
      setAdminWebFiles(res.data.children)
    });
    if(!res.ok){
      throw new Error(`Error ${res.status} : ${res.statusText}`)
    }
  } catch (err){}
};

export const downloadAdminWebFiles = async(filename,adminWebFile) => {
  var endpoint = "/admin/webfiles"+adminWebFile+"?download=true"
  try{
      const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
        headers: { 'Accept': 'application/octet-stream' }
  });
  res.blob().then((res)=>{
      console.log("after response")
      const blob=res;
      const url=window.URL.createObjectURL(blob);
      window.open(url,'_blank')
      // const link =document.createElement('a');
      // link.href=url;
      // link.download=filename;
      // document.body.appendChild(link);
      // link.click();
      // link.remove();
      // window.URL.revokeObjectURL(url);
  })
}catch (err){}
}

export const uploadAdminWebFiles = async(adminWebFile) => {
  var endpoint = "/admin/webfiles/webfile/images/"+adminWebFile.name
  const form = new FormData();
  form.append('file',adminWebFile);
form.append('isDirectory', 'false');
form.append('file', 'multipart');
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint+"?isDirectory=false&file=multipart", {
      method: "POST",
      body: form,

    });
    if(res.ok)
        console.log("Uploaded the file successfully "+adminWebFile)
    else{
      throw new Error(`Error ${res.status} : ${res.statusText}`)
    }
  } catch (err){}
};

export const deleteAdminWebFiles = async(adminWebFile) => {
  var endpoint = "/admin/webfiles/"+adminWebFile
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    if(res.ok)
      console.log("deleted file successfully"+adminWebFile)
    else{
      throw new Error(`Error ${res.status} : ${res.statusText}`)
    }
  } catch (err){}
};

export const getAnnouncements = async (
  state,
  agency,
  priority,
  roadway,
  type,
  includeExpired,
  setAnnouncements
) => {
  var endpoint = "/admin/announcements/all.json?";
  if (state !== "all") endpoint = endpoint + "&state=" + state;
  if (agency !== "all") endpoint = endpoint + "&agency=" + agency;
  if (priority !== "all")
    endpoint = endpoint + "&priority=" + upperCase(priority);
  if (roadway !== "all") endpoint = endpoint + "&roadway=" + roadway;
  if (type !== "all") endpoint = endpoint + "&type=" + type;
  if (!includeExpired) endpoint = endpoint + "&includeExpired=" + includeExpired;
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
    });
    res.json().then((res) => {
      setAnnouncements(res.data)
    });

    if (!res.ok) {
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {}
};

export const getAnnouncementLogs = async (
  announcementId,
  setAnnouncementLogs
) => {
  var endpoint = "/admin/announcements/" + announcementId + "/logs.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
    });
    res.json().then((res) => {
      setAnnouncementLogs(res.data);
    });

    if (!res.ok) {
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {}
};

export const getAnnouncement = async (announcementId, setAnnouncement) => {
  var endpoint =
    "/admin/announcements/" + announcementId + "/announcement.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
    });
    res.json().then((res) => {
      setAnnouncement(res.data);
      var updatedIcon=res.data.icon;
      if(res.data.icon!==null && res.data.icon!=="" && !res.data.icon.startsWith('/'))
        updatedIcon='/'+res.data.icon
      setAnnouncement((prev) => ({ ...prev, icon: updatedIcon }));
    });

    if (!res.ok) {
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {}
};

export const createAnnouncement = async (announcement) => {
  var endpoint = "/admin/announcements/announcement.json";
  announcement.creationDate=new Date().toISOString();
  announcement.lastUpdate=new Date().toISOString();
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(announcement),
    })
      .then((res) => {
        alert("New Announcement Created");
      })
      .then((data) => {
      });

    if (!res.ok) {
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {}
};

export const saveAnnouncement = async (announcement) => {
  var endpoint =
    "/admin/announcements/" + announcement.id + "/announcement.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(announcement),
    })
      .then((res) => {
        alert("Announcement has been Updated Successfully.");
      })
      .then((data) => {
      });

    if (!res.ok) {
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {}
};

export const deleteAnnouncement = async (announcement) => {
  var endpoint =
    "/admin/announcements/" + announcement.id + "/announcement.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "DELETE",
    }).then((res) => {
      alert("Announcement has been Deleted Successfully.");
    });
    if (!res.ok) {
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {}
};
